module.exports = __webpack_public_path__ + "img/cover.56d00484.jpg";